export const DEFAULT_ORGANIZATION_AVATAR = 'https://app.alyce.com/images/noimage.png';
